module.exports = __webpack_public_path__ + "img/galeria-ornamentales-5.f9cc29d0.jpg";